import SchemaMarkup from "../Components/SchemaMarkup";

const PersonSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Person",

    "@id": "https://msayurved.com/#person",

    "name": "Dr. Jigar Gor",

    "url": "https://msayurved.com/about-us/",

    "image": "https://msayurved.com/dr-jigar-gor.webp",

    "jobTitle": "Ayurveda Consultant",

    "description":
      "Dr. Jigar Gor is an Ayurveda Consultant Doctor providing Ayurvedic consultations and traditional Ayurvedic treatments in Bhuj, Kutch, Gujarat.",

    "worksFor": {
      "@id": "https://msayurved.com/#medicalclinic"
    },

    "affiliation": {
      "@id": "https://msayurved.com/#medicalclinic"
    },

    "sameAs": [
      "https://www.facebook.com/dr.jigargor.ayurveda",
      "https://www.instagram.com/dr.jigargor.ayurveda/",
      "https://www.youtube.com/@dr.jigargor.ayurveda"
    ]
  };

  return <SchemaMarkup data={schema} />;
};

export default PersonSchema;